import { l10n } from '../../i18n/Localization';
import DateTimeHelper from '../../utils/DateTimeHelper';
import GameCode from '../games/GameCode';
import Character from './Character';

class Sc2Character extends Character {
    static className = 'Sc2Character';

    static serialize(sc2Character) {
        const className = this.className;

        const id = sc2Character.id;
        const userId = sc2Character.userId;
        const playerId = sc2Character.playerId;
        const gameCode = sc2Character.gameCode.wireName;
        const identificationName = sc2Character.identificationName;
        const verificationNumber = sc2Character.verificationNumber;
        const isVerified = sc2Character.isVerified;
        const gameDataRefreshedAt = DateTimeHelper.convertDateToISO8601String(sc2Character.gameDataRefreshedAt);

        const profileUrl = sc2Character.profileUrl;
        const regionId = sc2Character.regionId;
        const realmId = sc2Character.realmId;
        const profileId = sc2Character.profileId;
        const name = sc2Character.name;
        const avatarUrl = sc2Character.avatarUrl;

        const createdAt = DateTimeHelper.convertDateToISO8601String(sc2Character.createdAt);
        const updatedAt = DateTimeHelper.convertDateToISO8601String(sc2Character.updatedAt);

        return {
            className,
            id,
            userId,
            playerId,
            gameCode,
            identificationName,
            verificationNumber,
            isVerified,
            gameDataRefreshedAt,
            profileUrl,
            regionId,
            realmId,
            profileId,
            name,
            avatarUrl,
            createdAt,
            updatedAt,
        };
    }

    static deserialize(jsonObj) {
        const id = jsonObj.id;
        const userId = jsonObj.userId;
        const playerId = jsonObj.playerId;
        const gameCode = GameCode.valueOfWireName(jsonObj.gameCode);
        const identificationName = jsonObj.identificationName;
        const verificationNumber = jsonObj.verificationNumber;
        const isVerified = jsonObj.isVerified;
        const gameDataRefreshedAt = DateTimeHelper.convertISO8601StringToDate(jsonObj.gameDataRefreshedAt);

        const profileUrl = jsonObj.profileUrl;
        const regionId = jsonObj.regionId;
        const realmId = jsonObj.realmId;
        const profileId = jsonObj.regionId;
        const name = jsonObj.name;
        const avatarUrl = jsonObj.avatarUrl;

        const createdAt = DateTimeHelper.convertISO8601StringToDate(jsonObj.createdAt);
        const updatedAt = DateTimeHelper.convertISO8601StringToDate(jsonObj.updatedAt);

        return (new Sc2Character(id, userId, playerId, gameCode, identificationName, verificationNumber, isVerified, gameDataRefreshedAt, profileUrl, regionId, realmId, profileId, name, avatarUrl, createdAt, updatedAt));
    }

    static createInstance(userId, identificationName, profileUrl, createdAt, updatedAt) {
        const id = null;
        const playerId = null;
        const gameCode = GameCode.starcraft2;
        const verificationNumber = null;
        const isVerified = null;
        const gameDataRefreshedAt = null;

        const regionId = null;
        const realmId = null;
        const profileId = null;
        const name = null;
        const avatarUrl = null;

        return (new Sc2Character(id, userId, playerId, gameCode, identificationName, verificationNumber, isVerified, gameDataRefreshedAt, profileUrl, regionId, realmId, profileId, name, avatarUrl, createdAt, updatedAt));
    }

    profileUrl;
    regionId;
    realmId;
    profileId;
    name;

    // undefinedable
    // nullable
    avatarUrl;

    constructor(id, userId, playerId, gameCode, identificationName, verificationNumber, isVerified, gameDataRefreshedAt, profileUrl, regionId, realmId, profileId, name, avatarUrl, createdAt, updatedAt) {
        super(id, userId, playerId, gameCode, identificationName, verificationNumber, isVerified, gameDataRefreshedAt, createdAt, updatedAt);

        this.profileUrl = profileUrl;
        this.regionId = regionId;
        this.realmId = realmId;
        this.profileId = profileId;
        this.name = name;
        this.avatarUrl = avatarUrl;
    }

    merge(jsonObj) {
        super.merge(jsonObj);

        if (jsonObj.hasOwnProperty('profileUrl')) {
            this.profileUrl = jsonObj.profileUrl;
        }

        if (jsonObj.hasOwnProperty('regionId')) {
            this.regionId = jsonObj.regionId;
        }

        if (jsonObj.hasOwnProperty('realmId')) {
            this.realmId = jsonObj.realmId;
        }

        if (jsonObj.hasOwnProperty('profileId')) {
            this.profileId = jsonObj.profileId;
        }

        if (jsonObj.hasOwnProperty('name')) {
            this.name = jsonObj.name;
        }

        if (jsonObj.hasOwnProperty('avatarUrl')) {
            this.avatarUrl = jsonObj.avatarUrl;
        }
    }

    // references:
    // https://develop.battle.net/documentation/guides/regionality-and-apis
    // https://develop.battle.net/documentation/starcraft-2/community-apis
    static regionKeys = {
        '1': 'us',
        '2': 'eu',
        '3': 'kr',
        '5': 'cn',
    };

    static realmKeys = {
        '11': 'us',
        '12': 'latAm',
        '21': 'europe',
        '22': 'russia',
        '31': 'korea',
        '32': 'taiwan',
        '51': 'china',
    };

    get region() {
        const regionKey = Sc2Character.regionKeys[this.regionId];

        if (regionKey !== undefined) {
            return l10n.starcraft2.region[regionKey];
        } else {
            return l10n.starcraft2.region.unknown;
        }
    }

    get realm() {
        const regionIdRealmId = `${this.regionId}${this.realmId}`;
        const realmKey = Sc2Character.realmKeys[regionIdRealmId];

        if (realmKey !== undefined) {
            return l10n.starcraft2.realm[realmKey];
        } else {
            return l10n.starcraft2.realm.unknown;
        }
    }
}

export default Sc2Character;
